/**
 * DevExtreme (esm/__internal/scheduler/r1/components/base/date_header_text.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { createVNode, createFragment } from "inferno";
import { BaseInfernoComponent } from "../../../../core/r1/runtime/inferno/index";
const DateHeaderTextDefaultProps = {
  text: "",
  splitText: false
};
export let DateHeaderText = /*#__PURE__*/(() => {
  class DateHeaderText extends BaseInfernoComponent {
    constructor() {
      super(...arguments);
      this._textCache = null;
    }
    getTextParts() {
      if (null !== this._textCache) {
        return this._textCache;
      }
      const {
        text: text
      } = this.props;
      this._textCache = text ? text.split(" ") : [""];
      return this._textCache;
    }
    componentWillUpdate(nextProps) {
      if (this.props.text !== nextProps.text) {
        this._textCache = null;
      }
    }
    render() {
      const {
        splitText: splitText,
        text: text
      } = this.props;
      const textParts = this.getTextParts();
      return createFragment(splitText ? textParts.map(part => createVNode(1, "div", "dx-scheduler-header-panel-cell-date", createVNode(1, "span", null, part, 0), 2)) : text, 0);
    }
  }
  DateHeaderText.defaultProps = DateHeaderTextDefaultProps;
  return DateHeaderText;
})();